module.exports = __webpack_public_path__ + "img/business.8464133a.svg";